module.exports = __webpack_public_path__ + "img/tool_customize_black.c16f0a52.png";